/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import _ from 'lodash';
import {configureAdminResourceStates} from '../../common/controller/admin-resource-routing';
import {TeamCopyModalComponent} from './team-copy-modal.component';
import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {getTargetingType} from '../../targeting/targeting-constants';
import {getCountryName} from '../../common/directives/country-select/countries';
import {TeamResource} from '../../../components/api/resources/resource/team.resource';

export function teamStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('teams.team', TeamResource, 'app.adm', 'app/admin');
    
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'Team',
          editTag: 'adn-team-edit-page',
          pageWithReadOnly: true,
          twoPanel: {
            rightTag: 'adn-team-analysis-page'
          },
          listTag: 'adn-team-list-page',
          listData: {
            app: ['ADVERTISING', 'DATA', 'POLITICAL']
          },
          listResolve: {
            extension: /*@ngInject*/ function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();

              return {
                func: function(ctrl, afterFill) {
                  if (afterFill) {
                    _.map(ctrl.items, function(item) {
                      item.countryExpanded = getCountryName(item.country);
                    });
                    return;
                  }
                  ctrl.teamFields = ['name', 'type', 'externalReference'];
    
                  if (LocalNetworkProfile.isPureMarketplacePlatform()) {
                    ctrl.teamFields.push({param: '', label: 'targeting'});
                    ctrl.teamFields.push({param: '', label: 'fees'});
                    ctrl.teamFields.push('country');
                  }
    
                  ctrl.selFields = _.map(ctrl.teamFields, function(field) {
                    return _.isString(field) ? field : field.label;
                  });
    
                  ctrl.getTargetTranslation = function(apiValue) {
                    return getTargetingType(apiValue).title;
                  };
                }
              };
            },
            readOnly: /*@ngInject*/ function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
                && !LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
                && !LocalUserPermissions.hasNetwork(PERMISSIONS.axAdvertiserAdmin.apiKey)
                && !LocalUserPermissions.hasNetworkPermission('POLITICAL_ADMIN', null, 'POLITICAL');
            }
          },
          itemResolve: {
            copyConfig: function() {
              return {
                modalComponent: TeamCopyModalComponent,
                stateUrl: 'app.adm.teams.team',
                lcase: 'team',
                ucase: 'Team'
              };
            }
          }
        });
  }, adnRouterHelper);
}
